export const errorLog = (data) => {
  fetch('https://webapi.kaspersky.com/logger', {
    method: "POST",
    mode: "cors",
    body: JSON.stringify(data),
    headers: {
      'content-type': 'application/json',
      referer: 'https://www.kaspersky.com/',
    }
  });
};

export const ErrorTypes = {
  DownloadLinkNotFound: 'DownloadLinkNotFound',
  DownloadTagNotFound: 'DownloadTagNotFound',
  DownloadConfigNotFound: 'DownloadConfigNotFound',
  DownloadLanguageConfigNotFound: 'DownloadLanguageConfigNotFound',
  DownloadLanguageTranslationNotFound: 'DownloadLanguageTranslationNotFound',
};
